import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { NAV_LINKS, slug } from "../../lib/site";
import { GOLD, GOLD_FILL, SLATE, StarPulse } from "./kit";
import { useInvite } from "./InviteContext";
import MobileMenu from "./MobileMenu";
import NavDropdown from "./NavDropdown";

export default function SiteNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const openInvite = useInvite();
  const { pathname } = useLocation();
  return (
    <div className="sticky top-0 z-30 backdrop-blur-md bg-black/60 border-b" style={{ borderColor: "rgba(233,214,162,0.08)" }} data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="site-nav-home">
          <img src="/brand/maven-m.webp" alt="" width={20} height={26} className="block" />
          <span className="text-[11px] tracking-[0.34em] uppercase" style={{ color: "#c8bd9a", fontFamily: "Fraunces, serif" }}>Maven Skies</span>
        </Link>
        <nav className="hidden xl:flex items-center gap-5">
          {NAV_LINKS.map((l) =>
            l.children ? (
              <NavDropdown key={l.label} item={l} prefix="site-nav" className="text-[10.5px] tracking-[0.2em] uppercase transition-colors hover:text-white whitespace-nowrap"
                style={{ color: l.children[0].href === pathname ? GOLD : SLATE }} />
            ) : (
            <NavLink
              key={l.label}
              to={l.href}
              data-testid={`site-nav-${slug(l.label)}`}
              className="text-[10.5px] tracking-[0.2em] uppercase transition-colors hover:text-white whitespace-nowrap"
              style={({ isActive }) => ({ color: isActive ? GOLD : SLATE })}
            >
              {l.label}
            </NavLink>
            )
          )}
        </nav>
        <div className="flex items-center gap-3">
          <button type="button" onClick={openInvite} data-testid="site-nav-request-invitation" className="hidden sm:inline-flex relative items-center px-5 py-2.5 rounded-full text-[10px] tracking-[0.3em] uppercase font-semibold overflow-hidden" style={GOLD_FILL}>
            <StarPulse />
            <span className="relative z-[2]">Request Invitation</span>
          </button>
          <button type="button" onClick={() => setMenuOpen(true)} className="xl:hidden p-2 rounded-full transition hover:bg-white/[0.05]" style={{ color: GOLD }} data-testid="site-nav-menu-open" aria-label="Open menu">
            <Menu size={20} />
          </button>
        </div>
      </div>
      {menuOpen && <MobileMenu onClose={() => setMenuOpen(false)} />}
    </div>
  );
}
